import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAuth = () => {
    const { auth } = useAuth();   
    const location = useLocation();
    const from = location.state?.from?.pathname || "/"; 

    return (
        auth?.uid 
            ? <Outlet />
            : <Navigate to="Login" state={{ from : location }} replace />
    );
}

export default RequireAuth;